import type { ReactNode } from 'react'
import { LumpsumRecommendationActionType } from '../../../api/common.types'
import { RecommendationFundSingleSection } from './RecommendationFundSingleSection'
import { RecommendationFundsCarouselSection } from './RecommendationFundsCarouselSection'
import {
  RECOMMENDATION_CAROUSEL_FUND_CARD_WIDTH_CLASS,
  RECOMMENDATION_SINGLE_FUND_CARD_WIDTH_CLASS
} from './PlanRecommendationFundTile'

type RecommendationCounterFundsSectionFund = {
  isin?: string | null
  executed?: boolean | null
}

type RecommendationCounterFundsSectionProps<Fund extends RecommendationCounterFundsSectionFund> = {
  funds: Fund[]
  titleSingle: string
  titleMulti: string
  type: LumpsumRecommendationActionType
  onSelect: (selectedIndex: number) => void
  highlightIsin?: string
  sectionClassName?: string
  renderFundTile: (fund: Fund, widthClassName: string) => ReactNode
}

export function RecommendationCounterFundsSection<Fund extends RecommendationCounterFundsSectionFund>({
  funds,
  titleSingle,
  titleMulti,
  type,
  onSelect,
  highlightIsin = '',
  sectionClassName = '',
  renderFundTile
}: RecommendationCounterFundsSectionProps<Fund>) {
  if (funds.length === 0) {
    return null
  }

  if (funds.length > 1) {
    return (
      <RecommendationFundsCarouselSection
        title={titleMulti}
        funds={funds}
        onSelect={onSelect}
        sectionClassName={sectionClassName}
        type={type}
        highlightIsin={highlightIsin}
        renderFundCard={(fund) => renderFundTile(fund, RECOMMENDATION_CAROUSEL_FUND_CARD_WIDTH_CLASS)}
      />
    )
  }

  const singleFund = funds[0]

  return (
    <RecommendationFundSingleSection
      title={titleSingle}
      type={type}
      sectionClassName={sectionClassName}
      highlightIsin={highlightIsin}
      fundId={singleFund?.isin ?? ''}
    >
      {renderFundTile(singleFund, RECOMMENDATION_SINGLE_FUND_CARD_WIDTH_CLASS)}
    </RecommendationFundSingleSection>
  )
}
